import { usePage } from "@inertiajs/react"

export function useCsrfToken(): string {
  const { csrf_token } = usePage<{ csrf_token: string }>().props

  return csrf_token
}
